// plop_marker:layouts_import
import RichTextBlog from "./rich-text-blog/index.js";
export default {
    // plop_marker:layouts_add_layout
    RichTextBlog
};
